type AccordionArrowIconProps = {
  direction?: 'up' | 'down';
  size?: 'small' | 'large';
};

const DIMENSIONS = {
  large: { width: '32', height: '18', viewBox: '0 0 32 18' },
  small: { width: '24', height: '24', viewBox: '0 0 24 24' },
};

const PATHS = {
  large: {
    up: 'M15.9233 3.3345L1.66725 17.5905L0 15.9233L15.9233 0L31.8465 15.9233L30.1793 17.5905L15.9233 3.3345Z',
    down: 'M16.0767 14.6655L30.33275 0.4095L32 2.0767L16.0767 18L0.1535 2.0767L1.8207 0.4095L16.0767 14.6655Z',
  },
  small: {
    up: 'M20.2959 15.796C20.1914 15.9009 20.0672 15.9841 19.9304 16.0409C19.7937 16.0976 19.6471 16.1269 19.499 16.1269C19.351 16.1269 19.2043 16.0976 19.0676 16.0409C18.9309 15.9841 18.8067 15.9009 18.7021 15.796L12 9.09379L5.2959 15.796C5.08455 16.0073 4.79791 16.1261 4.49902 16.1261C4.20014 16.1261 3.91349 16.0073 3.70215 15.796C3.4908 15.5846 3.37207 15.298 3.37207 14.9991C3.37207 14.7002 3.4908 14.4136 3.70215 14.2022L11.2021 6.70222C11.3067 6.59734 11.4309 6.51413 11.5676 6.45735C11.7043 6.40057 11.851 6.37134 11.999 6.37134C12.1471 6.37134 12.2937 6.40057 12.4304 6.45735C12.5672 6.51413 12.6914 6.59734 12.7959 6.70222L20.2959 14.2022C20.4008 14.3067 20.484 14.4309 20.5408 14.5677C20.5976 14.7044 20.6268 14.851 20.6268 14.9991C20.6268 15.1472 20.5976 15.2938 20.5408 15.4305C20.484 15.5673 20.4008 15.6915 20.2959 15.796Z',
    down: 'M3.70215 8.20398C3.9135 7.99264 4.20014 7.87391 4.49902 7.87391C4.79791 7.87391 5.08455 7.99264 5.2959 8.20398L12 14.9062L18.7041 8.20398C18.9155 7.99264 19.2021 7.87391 19.501 7.87391C19.7999 7.87391 20.0865 7.99264 20.2979 8.20398C20.5092 8.41533 20.6279 8.70197 20.6279 9.00086C20.6279 9.29974 20.5092 9.58639 20.2979 9.79773L12.7979 17.2977C12.6933 17.4026 12.5691 17.4858 12.4323 17.5426C12.2956 17.5994 12.149 17.6285 12.001 17.6285C11.853 17.6285 11.7064 17.5994 11.5697 17.5426C11.4329 17.4858 11.3087 17.4026 11.2041 17.2977L3.70215 9.79773C3.5975 9.69309 3.51449 9.56886 3.45785 9.43213C3.40122 9.2954 3.37207 9.14885 3.37207 9.00086C3.37207 8.85286 3.40122 8.70632 3.45785 8.56959C3.51449 8.43286 3.5975 8.30862 3.70215 8.20398Z',
  },
};

function AccordionArrowIcon({
  direction = 'up',
  size = 'large',
}: AccordionArrowIconProps) {
  const { width, height, viewBox } = DIMENSIONS[size];
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox={viewBox}
      fill="none"
    >
      <path d={PATHS[size][direction]} fill="var(--purple-900)" />
    </svg>
  );
}

export default AccordionArrowIcon;
